import React from 'react';
import s from './styles.css';

interface ITextButtonProps {
  children: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export const TextButton: React.FC<ITextButtonProps> = ({ children, onClick, disabled = false }) => {
  return (
    <button className={s.button} onClick={e => onClick(e)} disabled={disabled}>
      {children}
    </button>
  );
};
